import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import patientsReducer from "./slices/patientsSlice";
import sessionsReducer from "./slices/sessionsSlice";
import uiReducer from "./slices/uiSlice";
import dashboardReducer from "./slices/dashboardSlice";
import { authMiddleware } from "./middleware/authMiddleware";

const appSlice = createSlice({
  name: "app",
  initialState: {
    isInitialized: false,
  },
  reducers: {
    setInitialized: (state) => {
      state.isInitialized = true;
    },
  },
});

export const { setInitialized } = appSlice.actions;

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    auth: authReducer,
    patients: patientsReducer,
    sessions: sessionsReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).concat(authMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
